export default __webpack_public_path__ + "static/media/Principal’s Office.c5f2db26.jpg";